import React from 'react';
import PropTypes from 'prop-types';
import { HotelSlider } from './HotelSlider';
import ChatMessage from './ChatMessage';
import { LOADING } from '../utils/constants';
import { LoadingComponent } from './LoadingComponent';

export const ChatDisplay = ({ messageArray, conversationApiStatus, loadingStep }) => (
  <div
    className="flex flex-column flex-justify-start pad-2-t flex-item-grow"
  >
    {messageArray
      .map(({
        id, isSentByUser, message, type, hotels,
      }) => {
        if (type === 'hotels') {
          return (
            <HotelSlider
              key={id}
              id={id}
              hotels={hotels}
            />
          );
        }
        return (
          <ChatMessage
            key={id}
            isSentByUser={isSentByUser}
            message={message}
          />
        );
      })}
    {conversationApiStatus === LOADING && (
    <LoadingComponent loadingStep={loadingStep} hasMessages={messageArray.length > 0} />
    )}
  </div>
);

ChatDisplay.propTypes = {
  messageArray: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  conversationApiStatus: PropTypes.string.isRequired,
  loadingStep: PropTypes.string.isRequired,
};
